export const transformFormFieldValueMap = (formFieldValueMap) => {
  return {
    id: formFieldValueMap?.id || null,
    title: formFieldValueMap?.title || "",
    status: formFieldValueMap?.status || "1",
    createdBy: formFieldValueMap?.createdBy || "",
    createdTime: formFieldValueMap?.createdTime || "",
    modifiedBy: formFieldValueMap?.modifiedBy || "",
    modifiedTime: formFieldValueMap?.modifiedTime || "",
    menuAccess: formFieldValueMap?.menuAccess || [],
  };
};

export const Status = [
  { id: 0, name: "INACTIVE" },
  { id: 1, name: "ACTIVE" },
];

export const RoleBreadcrumb = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Roles", path: "/roles" },
  { label: "Create Role", path: "#" },
];

export const basicDetail = [
  {
    name: "title",
    rule: {
      required: true,
    },
    label: "Role Title",
    type: "text",
  },
];

export const editMode = [
  {
    name: "modifiedTime",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Edit Time",
    type: "text",
  },
  {
    name: "modifiedBy",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Edit By",
    type: "text",
  },
  {
    name: "createdTime",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Created Time",
    type: "text",
  },
  {
    name: "createdBy",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Created By",
    type: "text",
  },
];
